import React, { useState } from 'react';
import { Search, Shield, BarChart2 } from 'lucide-react';

const ThreeLensFramework = () => {
  const [activeLens, setActiveLens] = useState(null);

  const lenses = [
    {
      id: 1,
      icon: Search,
      title: "Equity Portfolio Quality",
      description: "Are the companies in the fund strong and financially sound?",
      details: [
        "Balance sheet strength analysis",
        "Cash flow sustainability assessment",
        "Management quality evaluation",
        "Business model durability check"
      ]
    },
    {
      id: 2,
      icon: Shield,
      title: "Bond Credit Quality",
      description: "Are the debt holdings secure and low-risk?",
      details: [
        "Credit rating assessment",
        "Default risk analysis",
        "Interest rate sensitivity check",
        "Duration and maturity profile"
      ]
    },
    {
      id: 3,
      icon: BarChart2,
      title: "Peer Group Ranking",
      description: "Is the fund consistently performing better than others in its category?",
      details: [
        "Historical performance comparison",
        "Risk-adjusted return evaluation",
        "Consistency of outperformance",
        "Volatility assessment"
      ]
    }
  ];

  return (
    <div className="bg-white pt-12">
      <div className="max-w-6xl w-full mx-auto px-4 sm:px-6 lg:px-8 py-4 md:py-6 lg:py-8">
        <div className="text-center mb-16">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-[#113262] mb-4">What Is the Three-Lens Framework?</h2>
          <p className="mt-4 text-lg text-gray-600 max-w-2xl mx-auto">
            Our proprietary research model that screens and selects high-quality mutual funds through three critical checks before recommending any fund.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {lenses.map((lens) => (
            <div
              key={lens.id}
              className={`bg-white rounded-lg shadow-lg transition-all duration-300 hover:shadow-xl ${activeLens === lens.id ? 'ring-2 ring-[#1C52A0]' : ''}`}
              onClick={() => setActiveLens(activeLens === lens.id ? null : lens.id)}
            >
              <div className="p-6">
                <div className="w-12 h-12 bg-[#E8EEF6] rounded-lg flex items-center justify-center">
                  <lens.icon className="h-6 w-6 text-[#1C52A0]" />
                </div>
                <h3 className="mt-4 text-xl font-semibold text-[#113262]">{lens.title}</h3>
                <p className="mt-2 text-gray-600">{lens.description}</p>

                <div className={`mt-4 transition-all duration-300 ${activeLens === lens.id ? 'max-h-48' : 'max-h-0 overflow-hidden'}`}>
                  <ul className="space-y-2">
                    {lens.details.map((detail, index) => (
                      <li key={index} className="flex items-center text-gray-600">
                        <div className="w-1.5 h-1.5 bg-[#F49611] rounded-full mr-2"></div>
                        {detail}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          ))}
        </div>
        
        <div className="mt-4 p-2 bg-[#E8EEF6] rounded-lg text-center">
          <p className="text-sm text-[#113262]">
            This framework filters out poor-quality funds and focuses only on those with a 
            <strong className="text-[#1C52A0]"> high probability of delivering stable, long-term results</strong>.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ThreeLensFramework;